
const whiteList = [
  '/login' // 登录页
//   '/register',
//   '/404'
]

export default whiteList
